export { default as isBrowser } from "./is-browser"
